import React from 'react'
import LoadingAnimation from '../assets/animations/feather-loading.json'
import Lottie from 'lottie-react'

interface LoadingScreenProps {
  isExiting: boolean
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ isExiting }) => (
  <div
    className={`fixed inset-0 z-50 flex items-center justify-center bg-zinc-900 text-white transition-opacity duration-200 ${
      isExiting ? 'pointer-events-none opacity-0' : 'opacity-100'
    }`}
  >
    <Lottie
      animationData={LoadingAnimation}
      loop={false}
      className="max-w-64"
    />
  </div>
)

export default LoadingScreen
